import { useEffect, useState } from "react";
import { GameChrome } from "../../app/GameChrome.js";
import { GameProvider } from "../../app/GameProvider.js";
import { registerCustomStage } from "../../content/customRegistry.js";
import { startStageCommand } from "../../domain/startStage.js";
import { loadOneStage } from "./customStagesClient.js";
import { toPlayable } from "./toPlayable.js";
import { editorExit } from "../result/resultExit.js";

export function TryCustomRun({ id }: { id: string }) {
  const [ready, setReady] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void loadOneStage(id, localStorage).then((record) => {
      if (!record) {
        setError("ステージが見つからない");
        return;
      }
      const playable = toPlayable(record);
      registerCustomStage(playable.stage, playable.cases, record);
      setReady(record.id);
    });
  }, [id]);

  if (error) {
    return (
      <main className="maker-hub">
        <p>{error}</p>
        <a href="/stage-maker">一覧へ</a>
      </main>
    );
  }
  if (!ready) return <p className="maker-hub">読み込み中</p>;
  return (
    <GameProvider skipSave start={[{ type: "OPEN_STAGE_SELECT" }, startStageCommand(ready)]}>
      <GameChrome resultExit={editorExit(ready)} />
    </GameProvider>
  );
}
